import { createEventFactory, createName } from '@cp/shared/tracking';

export const notificationEnabled = createEventFactory({
  name: createName('notification', 'enabled'),
});

export const notificationBannerClick = createEventFactory({
  name: createName('notification', 'banner', 'click'),
});
